// components/SkeletonLoader.tsx
import React from "react";

interface SkeletonLoaderProps {
  count?: number;
}

export const ResellingSkeletonLoader: React.FC<SkeletonLoaderProps> = ({ 
  count = 6, 
}) => {
  return (
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {[...Array(count)].map((_, index) => (
          <div
            key={index}
            className="bg-white dark:bg-gray-800 rounded-2xl border-2 border-gray-100 dark:border-gray-700 shadow-sm animate-pulse"
          >
            {/* Card Header */}
            <div className="p-6 pb-4">
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3 flex-1">
                  <div className="p-3 bg-gray-200 dark:bg-gray-700 rounded-xl">
                    <div className="w-6 h-6 bg-gray-300 dark:bg-gray-600 rounded"></div>
                  </div>
                  <div className="flex-1 space-y-2">
                    <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-3/4"></div>
                    <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-full"></div>
                  </div>
                </div>
                <div className="w-11 h-6 bg-gray-200 dark:bg-gray-700 rounded-full"></div>
              </div>

              {/* Base Price Skeleton */}
              <div className="p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg">
                <div className="flex justify-between items-center">
                  <div className="w-16 h-4 bg-gray-200 dark:bg-gray-600 rounded"></div>
                  <div className="w-12 h-6 bg-gray-300 dark:bg-gray-500 rounded"></div>
                </div>
              </div>
            </div>

            {/* Card Body */}
            <div className="px-6 pb-6 space-y-4">
              {/* Pricing Type Selector Skeleton */}
              <div className="space-y-2">
                <div className="w-24 h-4 bg-gray-200 dark:bg-gray-700 rounded"></div>
                <div className="w-full h-10 bg-gray-200 dark:bg-gray-700 rounded-lg"></div>
              </div>

              {/* Multiplier Skeleton */}
              <div className="bg-gray-50 dark:bg-gray-700/50 rounded-xl p-4 space-y-3">
                <div className="flex justify-between">
                  <div className="w-20 h-4 bg-gray-200 dark:bg-gray-600 rounded"></div>
                  <div className="w-8 h-5 bg-gray-300 dark:bg-gray-500 rounded"></div>
                </div>
                <div className="w-full h-2 bg-gray-200 dark:bg-gray-600 rounded"></div>
                <div className="flex justify-between">
                  <div className="w-4 h-3 bg-gray-200 dark:bg-gray-600 rounded"></div>
                  <div className="w-4 h-3 bg-gray-200 dark:bg-gray-600 rounded"></div>
                </div>
              </div>

              {/* Profit Display Skeleton */}
              <div className="grid grid-cols-2 gap-3 pt-2">
                {[...Array(2)].map((_, i) => (
                  <div key={i} className="text-center p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg space-y-2">
                    <div className="w-12 h-3 bg-gray-200 dark:bg-gray-600 rounded mx-auto"></div>
                    <div className="w-16 h-5 bg-gray-300 dark:bg-gray-500 rounded mx-auto"></div>
                  </div>
                ))}
              </div>
            </div>

            {/* Card Footer */}
            <div className="px-6 py-4 bg-gray-50 dark:bg-gray-700/30 rounded-b-2xl border-t border-gray-100 dark:border-gray-600">
              <div className="w-full h-12 bg-gray-200 dark:bg-gray-700 rounded-xl"></div>
            </div>
          </div>
        ))}
      </div>
    );
};